
import { actions } from "@gsd/redux-store-backoffice";
import React from "react";
import autobind from "react-autobind";
import { connect } from "react-redux";
import type { Dispatch } from "redux";
import Roles from "../component/Roles/Roles";

const {
  idmBackOffice: {
    creators: {
      getRoles,
      upsertRole
    }
  }
} = actions;

const mapStateToProps = (state: any) => ({
  ...state.idmBackOffice
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    getRoles: () => dispatch(getRoles()),
    upsertRole: (obj: any) => dispatch(upsertRole(obj)),
  };
};

type RolesContainerProps = ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class RolesContainer extends React.Component<RolesContainerProps> {
  constructor(props:RolesContainerProps) {
    super(props);
    autobind(this);
  }

  async componentDidMount() {
    await this.props.getRoles();
  }
  _upsertRole = async (obj: any) => {
    await this.props.upsertRole(obj);
    await this.props.getRoles();
  };

  render() {
    const { roles } = this.props;
    return (
      <Roles
        dataElements={roles}
        upsertEntity={this._upsertRole.bind(this)}
      />
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RolesContainer);
